import React from 'react'
import LoginPageRight from './LoginPageRight'
import LoginPageLeft from './LoginPageLeft'

const LoginPage = () => {
  return (
    <div className="p-4 flex lg:gap-10 gap-0 relative">
      <div className="md:block hidden w-1/2">
        <LoginPageLeft />
      </div>
      <div className="md:w-1/2 w-full">
        <LoginPageRight />
      </div>
    </div>
  )
}

export default LoginPage
